export default "__VITE_ASSET__DdqwlJTM__"